import request from '@/utils/request'

const url = '/home/honor/'
const api = {
  gethonor (data) {
    return request({
      url: url + 'gethonor',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/honor.js